import { Component, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Catches a failed lazy route chunk (e.g. a 404 on a stale hashed filename
// right after a redeploy) so navigation shows a retry prompt instead of
// unmounting the whole app to a blank page. Suspense alone only covers the
// pending state, not a thrown error, and React error boundaries can only be
// class components — there's no hook equivalent.
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream px-6 text-center">
          <p className="text-sm text-ink-soft">
            Une erreur est survenue au chargement de la page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white"
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
